import React, { memo, useState, forwardRef, useEffect } from 'react';
import { Input } from 'antd';

// import PropTypes from 'prop-types';
// import '@style/modules/insights/analysisInsightList.scss';
import '../../../styles/modules/analysis/analysisRight.scss';
const InsightTextarea = forwardRef((props, ref) => {
  const { maxLength, value = '', onChange, ...rest } = props;
  const [inputLength, setInputLength] = useState(value ? value.length : 0);
  const InputOnchangeFunc = (e) => {
    setInputLength(e.target.value.length);
    onChange(e);
  };
  useEffect(() => {
    if (!value) {
      setInputLength(0);
      return;
    }
    setInputLength(Math.min(value.length, maxLength));
  }, [value, maxLength]);
  return (
    <>
      <Input.TextArea
        {...rest}
        value={value}
        maxLength={maxLength}
        onChange={InputOnchangeFunc}
        ref={ref}
      />
      <div className="length-limit">
        {inputLength}/{maxLength}
      </div>
    </>
  );
});

export default memo(InsightTextarea);
